import { GantSizeWiseModel } from "./gant-size-wise-data";


export class GantOrderDataModel {

    id: number;
    poNumber: string;
    deliveryAddress: string;
    style: string;
    status: string;
    // colorCode: string;
    shipMode: string;
    deliveryDate: string;
    sizeWiseData: GantSizeWiseModel[];

    constructor(

        id: number,
        poNumber: string,
        deliveryAddress: string,
        style: string,
        status: string,
        // colorCode: string,
        shipMode: string,
        deliveryDate: string,
        sizeWiseData: GantSizeWiseModel[],

    ) {
        this.id = id
        this.poNumber = poNumber
        this.deliveryAddress = deliveryAddress
        this.style = style
        this.status = status
        // this.colorCode = colorCode
        this.shipMode = shipMode
        this.deliveryDate = deliveryDate
        this.sizeWiseData = sizeWiseData
    }
}


